import routes from './routes'
import * as components from './components'
import * as links from './links'

export default {
  components,
  links,
  routes
}



// WEBPACK FOOTER //
// ./src/features/PublicOffer/index.js